module.exports = __webpack_public_path__ + "img/capitano_min.d476b0e4.jpeg";